var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',[_c('TruckParkingsLayer',{attrs:{"loaded":_vm.loaded,"layerVisibility":_vm.layerVisibility}}),_c('TruckParkingsSecuredLayer',{attrs:{"loaded":_vm.loaded,"layerVisibility":_vm.layerVisibility}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }